import { useState } from 'react';
import type { MiceNeedView } from '@voll-intelligence/domain';

/**
 * O que está aberto por cima da lista: painel do viajante, voucher, revisão da compra, verificação.
 * `profileFocus`: o painel foi aberto por "Completar cadastro" e vai direto à seção Cadastro;
 * `profileNeed`: a necessidade da revisão da compra, quando foi ela quem abriu.
 */
export function useTravelerOverlays() {
  const [travelerId, setTravelerId] = useState<string | null>(null);
  const [profileFocus, setProfileFocus] = useState(false);
  const [profileNeed, setProfileNeed] = useState<MiceNeedView | null>(null);
  const [orderId, setOrderId] = useState<string | null>(null);
  const [purchase, setPurchase] = useState<MiceNeedView[] | null>(null);
  const [verifyId, setVerifyId] = useState<string | null>(null);
  return {
    travelerId,
    orderId,
    purchase,
    verifyId,
    profileFocus,
    profileNeed,
    openTraveler: (id: string) => {
      setProfileFocus(false);
      setProfileNeed(null);
      setTravelerId(id);
    },
    /** `need`: a necessidade da revisão da compra, para abrir o viajante fora da lista filtrada. */
    openProfile: (id: string, need: MiceNeedView | null = null) => {
      setProfileFocus(true);
      setProfileNeed(need);
      setTravelerId(id);
    },
    openOrder: setOrderId,
    openPurchase: setPurchase,
    openVerify: setVerifyId,
    closeDrawers: () => {
      setProfileFocus(false);
      setProfileNeed(null);
      setTravelerId(null);
      setOrderId(null);
    },
    closePurchase: () => {
      setPurchase(null);
    },
    closeVerify: () => {
      setVerifyId(null);
    },
  };
}

export type TravelerOverlayState = ReturnType<typeof useTravelerOverlays>;
